import React from "react"
import {Link, useParams} from "react-router-dom"
import {AsyncResultComponent} from "../../containers/AsyncResult/AsyncResult"
import {useAsyncResult} from "../../hooks/useAsyncResult"
import {useAccessToken} from "../../services/auth"
import {getManagedSolutionsUser} from "../../resources/managedSolutions"
import {useRefreshToken} from "../../hooks/useRefreshToken"
import TitleBar from "../../components/TitleBar/TitleBar"
import {MainSection} from "../../containers/MainSection/MainSection"
import {startCase} from "lodash"
import moment from "moment"
import HorizontalField from "../../components/HorizontalField/HorizontalField"
import {deriveFunnelStage} from "../../components/ManagedSolutionsUsers/funnelStage"

export default function ManagedSolutionsUserPage() {
	const {userId = ""} = useParams<{userId: string}>()
	const accessToken = useAccessToken()
	const [refreshToken, refresh] = useRefreshToken()
	const asyncResult = useAsyncResult(() => getManagedSolutionsUser(accessToken, userId), [refreshToken, userId])

	return (
		<>
			<AsyncResultComponent asyncResult={asyncResult} refresh={refresh}>
				{({value: user}) => {
					const {attributes, relationships} = user.data
					const funnelStage = deriveFunnelStage(user.data)
					const stageDisplay = funnelStage.detail ? `${funnelStage.label} · ${funnelStage.detail}` : funnelStage.label
					const createdAt = attributes.createdAt ? moment(attributes.createdAt).format("L LT") : undefined
					const applicationFormId = relationships?.applicationForm?.data?.id
					const applicationId = relationships?.application?.data?.id
					const customerId = relationships?.customer?.data?.id

					return (
						<>
							<TitleBar
								title={`User ${user.data.id}`}
								breadcrumbs={[{text: "Users", path: "/managed-solutions/users"}]}
								meta={[{text: stageDisplay}]}
							/>

							<MainSection>
								<div className="columns">
									<div className="column is-4">
										<div className="card">
											<div className="card-header">
												<p className="card-header-title">User Details</p>
											</div>
											<div className="card-content">
												<HorizontalField label="User ID">
													<input type="text" className="input is-static" readOnly value={user.data.id} />
												</HorizontalField>
												<HorizontalField label="External User ID">
													<input type="text" className="input is-static" readOnly value={attributes.userId} />
												</HorizontalField>
												<HorizontalField label="Role">
													<input
														type="text"
														className="input is-static"
														readOnly
														value={startCase(attributes.userRole)}
													/>
												</HorizontalField>
												<HorizontalField label="Status">
													<input
														type="text"
														className="input is-static"
														readOnly
														value={startCase(attributes.status)}
													/>
												</HorizontalField>
												{createdAt && (
													<HorizontalField label="Created At">
														<input type="text" className="input is-static" readOnly value={createdAt} />
													</HorizontalField>
												)}
												{attributes.applicationFormStage && (
													<HorizontalField label="Form Stage">
														<input
															type="text"
															className="input is-static"
															readOnly
															value={startCase(attributes.applicationFormStage)}
														/>
													</HorizontalField>
												)}
												{attributes.applicationStatus && (
													<HorizontalField label="Application Status">
														<input
															type="text"
															className="input is-static"
															readOnly
															value={startCase(attributes.applicationStatus)}
														/>
													</HorizontalField>
												)}
												{applicationFormId && (
													<HorizontalField label="Application Form">
														<Link className="link" to={`/managed-solutions/application-forms/${applicationFormId}`}>
															{applicationFormId}
														</Link>
													</HorizontalField>
												)}
												{applicationId && (
													<HorizontalField label="Application">
														<Link className="link" to={`/managed-solutions/applications/${applicationId}`}>
															{applicationId}
														</Link>
													</HorizontalField>
												)}
												{customerId && (
													<HorizontalField label="Customer">
														<Link className="link" to={`/managed-solutions/customers/${customerId}`}>
															{customerId}
														</Link>
													</HorizontalField>
												)}
											</div>
										</div>
									</div>
								</div>
							</MainSection>
						</>
					)
				}}
			</AsyncResultComponent>
		</>
	)
}
